export default __webpack_public_path__ + "static/media/mximg1.ee57b25a.webp";